module.exports = __webpack_public_path__ + "static/media/img24.893963b3.jpg";